/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompropertyname2Inputs */

const de_entity_custompropertyname2 = /** @type {(inputs: Entity_Custompropertyname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel Angezeigter Name`)
};

/** @type {(inputs: Entity_Custompropertyname2Inputs) => LocalizedString} */
const en_entity_custompropertyname2 = de_entity_custompropertyname2;

/**

* @param {Entity_Custompropertyname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompropertyname2 = /** @type {((inputs?: Entity_Custompropertyname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompropertyname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompropertyname2(inputs)
	return de_entity_custompropertyname2(inputs)
});
export { entity_custompropertyname2 as "entity_customPropertyName" }